module.exports = "<div class=\"content-component\">\r\n    <loader-component show-loader=\"$ctrl.showLoader\" description=\"Aguarde um instante...\"></loader-component>\r\n    <div ng-if=\"!$ctrl.showLoader\" ui-view></div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./components/content/content.html
// module id = 88
// module chunks = 0